import api from './api';

export interface BacQuestionSkill {
  id: number;
  name: string;
  weight: number;
}

export interface BacQuestion {
  id: number;
  ref: string;
  order: number;
  points: string;
  enonce_court: string;
  note: string;
  skills: BacQuestionSkill[];
}

export interface BacExercice {
  id: number;
  num: number;
  points: string;
  theme: string;
  questions: BacQuestion[];
}

export interface BacSujet {
  id: number;
  slug: string;
  annee: number;
  session: string;
  jour: string;
  title: string;
  total_points: string;
  bareme_source: string;
  sujet_pdf_url: string | null;
  corrige_pdf_url: string | null;
  corrige_apmep_pdf_url: string | null;
  nb_questions: number;
  nb_skills: number;
  themes: Array<{ num: number; points: string; theme: string }>;
  updated_at: string;
}

export interface BacSujetDetail extends BacSujet {
  exercices: BacExercice[];
  corrige_latex: string;
}

export interface CouvertureRequest {
  skill_ids?: number[];
  skill_set?: number;
  student?: number;
  annee?: number;
  sujets?: number[];
  prochains?: number;
}

export interface CouvertureResult {
  sources: Array<{ type: string; id: number; title?: string }>;
  mastered_count: number;
  sujets: Array<{
    id: number; slug: string; title: string; annee: number;
    points: number; total: number; part: number;
    questions_ok: number; questions_total: number;
  }>;
  ensemble: { points: number; total: number; part: number };
  prochains: Array<{ id: number; name: string; gain: number }>;
}

export interface RentabiliteRow {
  id: number;
  name: string;
  container: string | null;
  points_partage: number;
  points_partage_par_sujet: number;
  points_plein: number;
  nb_questions: number;
  nb_sujets: number;
}

class BacService {
  async getAll(annee?: number): Promise<BacSujet[]> {
    const response = await api.get('/bac-sujets/', { params: annee ? { annee } : {} });
    return response.data && response.data.results ? response.data.results : response.data;
  }

  async get(id: number): Promise<BacSujetDetail> {
    const response = await api.get(`/bac-sujets/${id}/`);
    return response.data;
  }

  async couverture(data: CouvertureRequest): Promise<CouvertureResult> {
    const response = await api.post('/bac-sujets/couverture/', data);
    return response.data;
  }

  async rentabilite(annee?: number): Promise<{ nb_sujets: number; skills: RentabiliteRow[] }> {
    const response = await api.get('/bac-sujets/rentabilite/', { params: annee ? { annee } : {} });
    return response.data;
  }
}

const bacService = new BacService();
export default bacService;
